import { render, staticRenderFns } from "./CenterContainer.vue?vue&type=template&id=313ec0a6&scoped=true&"
import script from "./CenterContainer.vue?vue&type=script&lang=js&"
export * from "./CenterContainer.vue?vue&type=script&lang=js&"
import style0 from "./CenterContainer.vue?vue&type=style&index=0&id=313ec0a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ec0a6",
  null
  
)

export default component.exports